import * as AC from './actions/actionTypes';
import _ from 'lodash';
import { SET_SEO, SET_TRANSLATE, SET_CATEGORY_BLOG } from './actions';

export default function reducer(state = {}, action) {

  switch (action.type) {
    case SET_SEO:
      return _.merge({}, state, { seo: action.seo });

    case SET_TRANSLATE:
      return _.merge({}, state, { locale: action.locale });

    case SET_CATEGORY_BLOG:
      return _.merge({}, state, { activeCategory: action.activeCategory });

    case AC.SET_USER_LOGGED:
      return _.merge({}, state, { isLogged: true, customer: action.customer });

    case AC.SET_USER_LOGOUT:
      return _.merge({}, state, { isLogged: false });

    default:
      return state;
  }

}
